<template>
  <div>
    <v-layout
      v-if="this.isChoiceScreen && !this.isMobile"
      align-center
      justify-center
      row
      wrap
      style="position: relative; width: auto; overflow-y: auto"
      :style="{
        position: 'relative',
        width: 'auto',
        overflowY: this.isMobile ? 'hidden' : 'auto',
      }"
    >
      <v-flex
        xs12
        sm12
        md12
        lg6
        xl6
        style="
          background-color: white;
          width: 100%;
          padding-left: 5rem;
          padding-right: 5rem;
          padding-top: 2rem;
        "
      >
        <v-container v-if="!this.modelDownloading" style="">
          <v-layout column justify-start align-center wrap>
            <span class="arcoscan-title">{{ COPY.CHOICE_SCREEN.TITLE }}</span>
            <v-layout align-center justify-center style="margin-top: 10px">
              <v-flex xs12>
                <span class="arcoscan-subtitle" :width="imageWidth">{{
                  COPY.CHOICE_SCREEN.DESCRIPTION
                }}</span>
              </v-flex>
            </v-layout>
            <v-layout
              align-center
              justify-center
              style="margin-top: 24px; width: 100%; overflow-x: hidden"
            >
              <v-img
                contain
                :src="require('@/assets/images/arcoscan/hero.png')"
                :width="imageWidth"
              />
            </v-layout>

            <v-flex
              xs12
              class="large-checkbox"
              v-show="!disclaimerAgreed"
              style="margin-top: 30px"
            >
              <v-checkbox v-model="disclaimerChecked" color="success"
                ><template v-slot:label>
                  <span id="checkboxLabel" style="color: black">{{
                    COPY.CHOICE_SCREEN.I_AGREE
                  }}</span>
                </template></v-checkbox
              ></v-flex
            >

            <v-flex xs12 style="margin-top: 20px"
              ><v-btn
                class="arcoscan-button"
                :disabled="!disclaimerChecked && !disclaimerAgreed"
                large
                color="#4E79A3"
                type="submit"
                @click="startVideo"
                >{{ COPY.CHOICE_SCREEN.BUTTON_TEXT }}</v-btn
              ></v-flex
            >
          </v-layout>
        </v-container>
      </v-flex>

      <!-- Please wait view in the choice screen in desktop -->
      <!--<style="position: absolute; left:calc(50% - 200px); top:calc(50% - 150px * 1.75)" > s-->
      <v-container style="padding: 0">
        <v-layout column>
          <v-flex v-if="this.modelDownloading" style="margin-top: 32px">
            <v-card style="border-radius: 20px; padding: 1rem">
              <v-card-text>
                <!-- style="padding-top:20%" -->
                <v-layout
                  align-center
                  justify-center
                  style="padding-bottom: 1.5rem"
                >
                  <v-progress-circular
                    :size="75"
                    indeterminate
                    color="grey"
                  ></v-progress-circular>
                </v-layout>
                <v-card-text
                  style="
                    text-align: center;
                    font-size: 3rem;
                    line-height: 4.5rem;
                  "
                >
                  <!-- padding-top:25%;-->
                  {{ COPY.LOADING_SCREEN.TEXT }}
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>

    <!-- Recording Screen -->
    <v-layout
      v-if="this.isRecordingScreen && !this.isMobile"
      column
      justify-start
      align-center
    >
      <v-container
        grid-list-md
        text-xs-center
        v-if="!this.imageProcessRunning || this.isRecording"
        style="position: relative; width: 100%"
      >
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="canvas-container">
            <v-container>
              <v-layout align-center justify-start column>
                <v-flex shrink style="position: relative; overflow: hidden">
                  <video
                    playsinline
                    autoplay="true"
                    ref="video"
                    :style="dynamicVideoStyle"
                    muted="true"
                    style="
                      transform: rotateY(180deg) !important;
                      -webkit-transform: rotateY(180deg) !important;
                      -moz-transform: rotateY(180deg) !important;
                    "
                  ></video>

                  <div
                    :class="{
                      'text-box-desktop': true,
                      'left-center': isRecording && !shouldApplyLeftCenter,
                    }"
                    style="z-index: 10"
                  >
                    <span class="dynamic-text-desktop">{{
                      videoOverlayText
                    }}</span>
                  </div>
                  <img
                    :src="arcoscan_overlay"
                    :style="{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      objectFit: 'cover',
                      height: '100%',
                      width: '100%',
                    }"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>

          <v-layout mt-4 align-center justify-center>
            <div v-if="!imageProcessRunning">
              <v-btn
                large
                style="color: black"
                color="white"
                type="submit"
                @click="tryAgain"
                class="arcoscan-button"
              >
                Exit
              </v-btn>
              <v-btn
                large
                color="#4E79A3"
                type="submit"
                class="arcoscan-button"
                @click="recordingButton"
              >
                Begin Scan
              </v-btn>
            </div>
            <div v-else style="text-align: center">
              <span style="position: relative; align-self: center; color: white"
                >Scanning...</span
              ><br />
              <progress-bar
                v-if="this.imageProcessRunning"
                :options="progressBarOptions"
                :value="progressValue"
                style="
                  width: 100%;
                  min-width: 320px;
                  max-width: 640px;
                  position: relative;
                  align-self: center;
                  border-radius: 20px;
                "
              />
            </div>
          </v-layout>
        </v-layout>
      </v-container>

      <v-container style="padding: 0">
        <v-layout column>
          <v-flex
            v-if="this.imageProcessRunning && !this.isRecording"
            style="margin-top: 32px"
          >
            <v-card style="border-radius: 20px">
              <v-card-text>
                <v-layout
                  align-center
                  justify-center
                  style="padding-bottom: 1rem"
                >
                  <v-progress-circular :size="50" indeterminate color="grey" />
                </v-layout>
                <v-card-text
                  style="text-align: center; font-size: 2rem; line-height: 3rem"
                >
                  Processing
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container style="padding: 0">
        <v-layout column>
          <v-flex v-if="this.modelDownloading" style="margin-top: 32px">
            <v-card style="border-radius: 20px; padding: 1rem">
              <v-card-text>
                <!-- style="padding-top:20%" -->
                <v-layout
                  align-center
                  justify-center
                  style="padding-bottom: 1.5rem"
                >
                  <v-progress-circular
                    :size="75"
                    indeterminate
                    color="grey"
                  ></v-progress-circular>
                </v-layout>
                <v-card-text
                  style="
                    text-align: center;
                    font-size: 3rem;
                    line-height: 4.5rem;
                  "
                >
                  <!-- padding-top:25%;-->
                  {{ COPY.LOADING_SCREEN.TEXT }}
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>

    <!-- Result Screen -->
    <v-layout v-if="isResultScreen" row wrap justify-center align-center>
      <v-flex
        class="mt-3"
        style="
          background-color: white;
          max-width: 36rem;
          width: auto;
          padding-left: 5rem;
          padding-right: 5rem;
          padding-top: 2rem;
          padding-bottom: 3rem;
          border-radius: 20px;
        "
      >
        <v-layout mtb-3 column justify-start align-center>
          <span
            class="text-xs-center arcoscan-success-msg"
            :style="{ fontSize: isMobile ? '22px' : '' }"
            >Verification Successful&nbsp;</span
          >
          <v-icon
            style="color: green; font-size: 32px"
            :style="{ fontSize: isMobile ? '8px' : '' }"
            large
            >check_circle_outline</v-icon
          >
        </v-layout>
        <v-layout
          :class="isMobile ? 'mt-5' : ''"
          class="mt-5"
          align-center
          justify-center
        >
          <img
            v-bind:src="imageResults[0].img"
            :width="isMobile ? '300' : ''"
            :height="isMobile ? '200' : ''"
            style="overflow-x: hidden; object-fit: contain"
          />
        </v-layout>
        <v-layout align-center justify-center column wrap class="mt-4">
          <span class="arcoscan-age-estimation-text"
          :style="{ fontSize: isMobile ? '20px' : '' }"
            >Age Estimation: {{ overallResult }}</span
          >
          <v-btn
            large
            color="#4E79A3"
            type="submit"
            class="arcoscan-button mt-4"
            @click="tryAgain"
          >
            Try Again
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- PermissionBlocked Screen -->
    <v-layout
      v-if="this.isPermissionBlockedScreen && !this.isMobile"
      row
      wrap
      style="position: relative"
    >
      <v-container class="text-xs-center">
        <v-layout
          align-center
          justify-center
          row
          wrap
          height="52px"
          style="margin-top: 32px"
        >
          <v-flex
            xs12
            style="
              background-color: white;
              max-width: 36rem;
              width: auto;
              padding-left: 5rem;
              padding-right: 5rem;
              padding-top: 2rem;
              padding-bottom: 3rem;
              border-top-radius: 20px;
              zindex: 20;
            "
          >
            <div class="arcoscan-title">
              {{ COPY.PERMISSION_BLOCKED_SCREEN.TITLE }}
            </div>
          </v-flex>
          <span class="arcoscan-title" style="margin-top: 32px"
            ><b>{{ COPY.PERMISSION_BLOCKED_SCREEN.SUBTITLE }}</b></span
          >
        </v-layout>
      </v-container>
      <v-container>
        <v-layout align-center justify-center>
          <span
            class="arcoscan-subtitle"
            style="width: 480px; text-align: center"
          >
            {{ COPY.PERMISSION_BLOCKED_SCREEN.BODY }}
          </span>
        </v-layout>
        <v-layout row align-center justify-center style="margin-top: 24px">
          <v-btn
            width="96px"
            large
            color="#042c54"
            type="submit"
            class="arcoscan-button"
            @click="retryPermissions"
          >
            Try Again
          </v-btn>
        </v-layout>
      </v-container>
      <v-flex
        v-show="false"
        height="126px"
        width="420px"
        style="
          margin-top: 32px;
          padding: 50px;
          position: absolute;
          left: 0%;
          right: 0%;
          top: calc(90% + 0px);
        "
      >
        <v-layout
          style="
            min-width: 320px;
            width: 80%;
            max-width: 480px;
            margin: auto;
            position: absolute;
            left: 0%;
            right: 0%;
            top: calc(50% + 80px);
            padding: 45px 30px 30px;
            background: #6fdcff;
            align-self: center;
            border-radius: 20.125px;
          "
        >
          <span style="text-align: center">
            You will be asked to enable your camera and microphone. Please note
            that your privacy and security is vitally important to us. Data or
            media is collected or stored only for auditing purposes.
          </span>
          <v-img
            :src="require('@/assets/images/privacy-icon.svg')"
            height="60px"
            width="60px"
            contain
            style="
              margin-top: 24px;
              position: absolute;
              left: calc(50% - 60px / 2);
              top: calc(50% - 130px);
              border-radius: 30px;
              background: #d5e2eb;
            "
          />
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Mobile -->

    <v-layout
      v-if="!this.isSupported"
      row
      wrap
      style="position: relative; background-color: white; border-radius: 20px"
    >
      <v-flex xs12> </v-flex>
      <v-container style="">
        <v-layout
          align-center
          justify-center
          height="52px"
          style="margin-top: 32px"
        >
          <span
            style="
              font-family: Fredoka One;
              font-style: normal;
              font-weight: normal;
              font-size: 43px;
              line-height: 52px;
              align-items: center;
              text-align: center;
              color: #18739d;
            "
            ><b>{{ COPY.NOT_SUPPORTED_SCREEN.TITLE }}</b></span
          >
        </v-layout>
      </v-container>
      <v-container>
        <v-layout align-center justify-center>
          <span
            style="
              font-family: Varela Round;
              font-style: normal;
              font-weight: normal;
              font-size: 20px;
              width: 480px;
              line-height: 22px;
              text-align: center;
              padding-bottom: 3rem;
              padding-right: 1rem;
              padding-left: 1rem;
            "
          >
            {{ COPY.NOT_SUPPORTED_SCREEN.BODY }}
          </span>
        </v-layout>
      </v-container>
    </v-layout>
    <!-- Choice Screen -->
    <v-layout
      v-if="this.isChoiceScreen && this.isMobile"
      row
      wrap
      style="position: relative"
    >
      <v-container
        v-if="!this.modelDownloading"
        style="background-color: white; border-radius: 20px"
      >
        <v-layout align-center justify-center column wrap>
          <span
            class="arcoscan-title"
            style="font-size: 40px; line-height: 40px"
            >{{ COPY.CHOICE_SCREEN.TITLE }}</span
          >
          <v-layout align-center justify-center style="max-width: 320px">
            <v-flex xs12>
              <span class="arcoscan-subtitle">{{
                COPY.CHOICE_SCREEN.DESCRIPTION
              }}</span>
            </v-flex>
          </v-layout>
          <v-layout
            align-center
            justify-center
            style="margin-top: 24px; width: 100%; overflow-x: hidden"
          >
            <img
              :src="require('@/assets/images/arcoscan/hero.png')"
              style="max-width: 320px"
            />
          </v-layout>

          <v-flex
            xs12
            class="large-checkbox"
            v-show="!disclaimerAgreed"
            style="margin-top: 8px"
          >
            <v-checkbox v-model="disclaimerChecked" color="success"
              ><template v-slot:label>
                <span id="checkboxLabel" style="color: black">{{
                  COPY.CHOICE_SCREEN.I_AGREE
                }}</span>
              </template></v-checkbox
            ></v-flex
          >

          <v-flex xs12
            ><v-btn
              class="arcoscan-button"
              :disabled="!disclaimerChecked && !disclaimerAgreed"
              large
              color="#4E79A3"
              type="submit"
              @click="startVideo"
            >
              {{ COPY.CHOICE_SCREEN.BUTTON_TEXT }}
            </v-btn></v-flex
          >
        </v-layout>
      </v-container>
      <!-- Please wait view in the choice screen in mobile TODO: adjust the style for a mobile-friendly one -->
      <!--<style="position: absolute; left:calc(50% - 200px); top:calc(50% - 150px * 1.75)" > s-->
      <v-container style="padding: 0">
        <v-layout column>
          <v-flex v-if="this.modelDownloading" style="margin-top: 32px">
            <v-card ma-5 style="border-radius: 20px">
              <v-card-text>
                <v-layout
                  align-center
                  justify-center
                  style="padding-bottom: 1rem"
                >
                  <v-progress-circular :size="50" indeterminate color="grey" />
                </v-layout>
                <v-card-text
                  style="text-align: center; font-size: 2rem; line-height: 3rem"
                >
                  <!-- padding-top:25%;-->
                  {{ COPY.LOADING_SCREEN.TEXT }}
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>

    <!-- Recording Screen -->
    <v-layout v-show="this.isRecordingScreen && this.isMobile" row wrap>
      <v-container v-if="!videoReady" style="padding: 0">
        <v-layout column>
          <v-flex>
            <v-card style="border-radius: 20px">
              <v-card-text>
                <v-layout
                  align-center
                  justify-center
                  style="padding-bottom: 1rem"
                >
                  <v-progress-circular :size="50" indeterminate color="grey" />
                </v-layout>
                <v-card-text
                  style="text-align: center; font-size: 2rem; line-height: 3rem"
                >
                  Processing
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container
        v-show="(!this.imageProcessRunning || this.isRecording) && videoReady"
        style="position: relative"
      >
        <v-layout align-center justify-center column wrap>
          <div style="position: relative; height: 100%">
            <video
              playsinline
              id="mobileVideo"
              autoplay="true"
              ref="video"
              muted="true"
              poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
              style="
                width: 100%;
                height: 100%;
                transform: rotateY(180deg);
                -webkit-transform: rotateY(180deg);
                -moz-transform: rotateY(180deg);
                position: relative;
                margin-top: 0px;
                background: transparent
                  url('data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=')
                  repeat 0 0;
                -webkit-background-size: 100%;
                -moz-background-size: 100%;
                -o-background-size: 100%;
                background-size: 100%;
              "
            ></video>
            <img
              id="still-mobile"
              :src="still_img_mobile"
              :style="{
                width: calculatedVideoWidth + 'px',
                height: calculatedVideoHeight + 'px',
                display: !isFaceStill || !this.isRecording ? 'none' : '',
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                objectFit: 'cover',
              }"
            />
            <img
              id="notstill-mobile"
              :src="nonstill_img_mobile"
              :style="{
                width: calculatedVideoWidth + 'px',
                height: calculatedVideoHeight + 'px',
                display: isFaceStill || !this.isRecording ? 'none' : '',
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                objectFit: 'cover',
              }"
            />
            <v-layout
              v-if="videoReady"
              align-center
              justify-center
              height="52px"
              style="
                border-radius: 16px;
                position: absolute;
                left: 10%;
                right: 10%;
                text-align: center;
                bottom: 20px;
              "
            >
              <span class="overlaytext-cl-mobile">{{
                this.videoOverlayText
              }}</span>
            </v-layout>
          </div>

          <v-layout
            align-center
            height="480px"
            v-bind:style="{ top: this.faceMaskOverlayPosition }"
            style="position: absolute; left: 0;    align-self: flex-end;  min-width:21px; max-width:42px; min-height:21px max-height:42px"
          >
          </v-layout>

          <v-layout align-center justify-center>
            <div v-if="!imageProcessRunning">
              <v-btn
                large
                style="color: black"
                color="white"
                @click="tryAgain"
                type="submit"
                class="arcoscan-button"
              >
                Exit
              </v-btn>
              <v-btn
                large
                color="#4E79A3"
                type="submit"
                class="arcoscan-button"
                @click="recordingButton"
              >
                Begin Scan
              </v-btn>
            </div>
            <div v-else style="text-align: center">
              <span style="position: relative; align-self: center; color: white"
                >Scanning...</span
              ><br />
              <progress-bar
                v-if="this.imageProcessRunning"
                :options="progressBarOptions"
                :value="progressValue"
                style="
                  width: 100%;
                  min-width: 320px;
                  max-width: 640px;
                  position: relative;
                  align-self: center;
                  margin-top: 16px;
                "
              />
            </div>
          </v-layout>
        </v-layout>
      </v-container>
      <v-flex
        v-if="this.imageProcessRunning && !this.isRecording"
        style="position: absolute; left: calc(12%); top: 20%"
      >
        <v-card
          ma-5
          height="100%"
          width="100%"
          min-height="200px"
          min-width="300px"
        >
          <v-card-text height="500px" style="padding-top: 20%">
            <v-layout align-center justify-center>
              <v-progress-circular
                :size="50"
                indeterminate
                color="grey"
              ></v-progress-circular>
            </v-layout>
            <v-card-text
              style="text-align: center; padding-top: 25%; font-size: 32px"
            >
              Processing
            </v-card-text>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex sm12 md3> </v-flex>
    </v-layout>

    <!-- Result Screen -->

    <!-- PermissionBlocked Screen -->
    <v-layout
      v-if="this.isPermissionBlockedScreen && this.isMobile"
      row
      wrap
      style="position: relative"
    >
      <v-container class="text-xs-center">
        <v-layout
          align-center
          justify-center
          row
          wrap
          height="52px"
          style="margin-top: 32px"
        >
          <v-flex xs12>
            <div class="arcoscan-title">ARCOSCAN</div>
          </v-flex>
          <span class="arcoscan-title" style="margin-top: 32px"
            ><b>{{ COPY.PERMISSION_BLOCKED_SCREEN.SUBTITLE }}</b></span
          >
        </v-layout>
      </v-container>
      <v-container>
        <v-layout align-center justify-center>
          <span
            class="arcoscan-subtitle"
            style="width: 480px; text-align: center"
          >
            {{ COPY.PERMISSION_BLOCKED_SCREEN.BODY }}
          </span>
        </v-layout>
        <v-layout row align-center justify-center style="margin-top: 24px">
          <v-btn
            width="96px"
            large
            color="#042c54"
            type="submit"
            class="arcoscan-button"
            @click="retryPermissions"
          >
            Try Again
          </v-btn>
        </v-layout>
      </v-container>
    </v-layout>
    <a ref="videoDownload" download />
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

import Task from "@/components/common/Task.vue";
import Infobox from "@/components/common/Infobox.vue";
import ProgressBar from "vuejs-progress-bar";
import unknown from "@/assets/images/unknown.jpg";

/*eslint no-undef: "warn"*/
/*eslint no-unused-components: "warn"*/
/* eslint-disable */

Vue.use(ProgressBar);

// MODELS
let model = null;
let audio_model = null;
let mask_model = null;
let blazemodel = null;
let blink_model = null;
let antispoof_model = null,
  antispoof_model2 = null;
let spoof_detection_active = true;

const leftEye_l = 263;
const leftEye_r = 362;
const leftEye_t = 386;
const leftEye_b = 374;

const rightEye_l = 133;
const rightEye_r = 33;
const rightEye_t = 159;
const rightEye_b = 145;

const horizonalLandmarks = [226, 446];
const verticalLandmarks = [10, 152];
const centerCoordinates = [6, 168, 173, 398];

const rightEye = [81, 55];
const leftEye = [42, 55];

let only_one_face = true;

let open_eyes_detected = true; //, open_eyes_detected_2=false;
let closed_eyes_detected = true; //, closed_eyes_detected_2=false;
let emotion_1_detected = false,
  emotion_2_detected = false,
  emotion_1 = "",
  emotion_2 = "";
const FACE_EXPRESSION_LABELS = ["neutral", "happy", "angry"]; // 'disgusted', 'fearful',  'sad',  'surprised'

//let face_promises = []
let images_per_second = 10; //20 // 10//10
let delayBecauseOfDistance = 0; // e.g. if it is five, it should make 5*(1000/images_per_second) microseconds of delay
const DELAY_INCREMENT_FOR_DISTANT_FACE = 5; // i.e. every time there is an action that requires us to wait until the user reacts, add this to delayBecauseOfDistance
const DELAY_INCREMENT_FOR_SUCCESSFUL = 1; // i.e. every time there is a successful capture, add this to delayBecauseOfDistance
let total_frames_to_analyze = 10; //5//10
let total_seconds = 20;
const minimum_face_percent = 0.4; //0.55
const maximum_face_percent = 0.65; //0.7
const maximum_test_count = 1; //10;
var test_id = 0;
var offset; // = tf.scalar(127.5);
var brightness_factor; // = tf.scalar(0.4); // old: 0.6

var BRIGHTNESS_GUIDANCE_LOWER_LIMIT = 85.0;

var brightness_lower_limit;
var brightness_mid_limit;
var brightness_upper_limit;
let minimum_acceptable_blur_score = 1250;
const face_confidence_limit = 0.975;
const mask_detect_threshold = 0.995;
const spoof_confidence_threshold = 0.96;

var imageCaptureDevice = null;
let countDownFactor = 0;

const instructionMsg = "Looking good, stay still!"; //"Please spell: \"A-E-I-O-U\"";
const tooFarMsg = "Slowly come closer to the camera";
const tooCloseMsg = "Slowly distance yourself from the camera";

const tooDarkMessage = "Face towards the light source";

const straightFaceMsg = "Please look straight to camera";
const turnFaceLeftMsg = "Please turn your head left";

const turnFaceRightMsg = "Please turn your head right";

const correctFaceToLeft = "Slightly move your head left";
const correctFaceToRight = "Slightly move your head right";
const correctFaceToUp = "Align your face with the camera (up)"; //"Slightly move your head up"
const correctFaceToDown = "Align your face with the camera (down)"; //"Slightly move your head down"
const correctFaceTiltLeft = "Slightly tilt your head left";
const correctFaceTiltRight = "Slightly tilt your head right";
const keepFaceInFrame = "Fill the frame fully with your face";

const left_rotation_threshold = 1.8; //1.5
const left_calibaration_flex = -0.5;
const right_rotation_threshold = 0.7; //0.65
const right_calibration_flex = 0.2;
const up_rotation_threshold = 0.435; //0.445; ////0.425 // 0.43 //
const down_rotation_threshold = 0.48; // 0.47;//0.46//55//0.47 // 0.465
const tilt_right_threshold = 0.15; // 0.1
const tilt_left_threshold = -0.15; // -0.1

const FACE_FRAME_COLOR = "#32EEDB";
const NUM_KEYPOINTS = 468;
const SILHOUETTE_KEYPOINTS = [
  // SILHOUETTE
  10, 338, 297, 332, 284, 251, 389, 356, 454, 323, 361, 288, 397, 365, 379, 378,
  400, 377, 152, 148, 176, 149, 150, 136, 172, 58, 132, 93, 234, 127, 162, 21,
  54, 103, 67, 109,

  // NOSE
  1, 2, 98, 327,
];

const MOUTH_TOP = [13, 82, 312, 81, 311];
const MOUTH_BOTTOM = [14, 87, 317, 178, 402];
const MOUTH_X_CLOSED_LIMIT = 0.5; //1.45;
const MOUTH_X_OPEN_LIMIT = 0.6; //1.75;
const TIMES_MOUTH_NEEDS_TO_OPEN = 5;
var currentTimesMouthOpen = 0;

var mouth_already_opened = false,
  mouth_already_closed = false,
  first_frame_before_mouth = false;

var previouslyTooDistant = false;

function gotMedia(mediaStream, isThisMobile) {
  console.log("ImageCapture disabled");
  return null;
  try {
    const mediaStreamTrack = mediaStream.getVideoTracks()[0];
    imageCaptureDevice = new ImageCapture(mediaStreamTrack);
    console.log(imageCaptureDevice);
    if (isThisMobile) {
      images_per_second = 5;
      total_frames_to_analyze = 2;
    }
  } catch (e) {
    console.log("Will not be able to use imageCapture. Reasons:");
    var error = e.toString();
    console.log(error);
  }
}

const seekListener = async function () {
  if (seekResolve) seekResolve();
};

const loadedData = async function () {
  let canvas = document.createElement("canvas");
  let context = canvas.getContext("2d");
  let [w, h] = [videoRef.videoWidth, videoRef.videoHeight];
  canvas.width = w;
  canvas.height = h;

  let frames = [];
  let interval = 1 / fps;

  let currentTime = 0;

  let duration = videoRef.duration;
  let intervalb = duration / 4;

  while (currentTime < duration) {
    videoRef.currentTime = currentTime;
    await new Promise((r) => (seekResolve = r));

    context.drawImage(videoRef, 0, 0, w, h);
    let base64ImageData = canvas.toDataURL();
    frames.push(base64ImageData);

    currentTime += intervalb;
  }
  resolve(frames);
};

function estimateRegression(pureRegressionOutput) {
  var casted = ~~pureRegressionOutput; // double inverse bits!
  console.log("Casted = " + casted);
  var remainder = pureRegressionOutput - casted;
  var label_dict = {
    0: [0, 2],
    1: [2, 4],
    2: [4, 8],
    3: [8, 13],
    4: [13, 18],
    5: [18, 21],
    6: [21, 25],
    7: [25, 28],
    8: [28, 32],
    9: [32, 36],
    10: [36, 40],
    11: [40, 45],
    12: [45, 50],
    13: [50, 60],
    14: [60, 70],
    15: [70, 120],
  };

  try {
    var ranges = label_dict["" + casted];
    var diff = (ranges[1] - ranges[0]) * remainder;
    var age = ranges[0] + diff;
    if (age >= 25) {
      return "25+";
    } else if (age < 13) {
      return "0-13";
    } else if (age < 18) {
      return "13-17";
    } else {
      return "18-24";
    }
  } catch (error) {
    console.log("Could not round, returning 100");
    return "25+"; //100
  }
}

function setToAgeBracket(inputAge) {
  var result;
  switch (inputAge) {
    case "childhood":
      result = "0 - 7";
      break;
    case "puberty":
      result = "8 - 12";
      break;
    case "adolescence":
      result = "13 - 17";
      break;
    case "early_adulthood":
      result = "18 - 24";
      break;
    case "adulthood":
      result = "25 - 34";
      break;
    case "middle_age":
      result = "35 - 49"; //
      break;
    case "seniority":
      result = "50+";
      break;
    default:
      result = "" + estimateRegression(inputAge); //.toFixed(1); //"" + inputAge;
      break;
  }
  return result;
}

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );
  return vars;
}

function detectIE() {
  try {
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    //console.log("Internet explorer check")
    if (!isIE) {
      // Fallback to UserAgent detection for IE
      if (navigator.userAgent.indexOf("MSIE") > 0) {
        return true;
      } else {
        return false;
      }
    }

    return true;
  } catch (e) {
    var error = e.toString();

    console.log(error);
  }
}

function getUrlParam(parameter, defaultvalue) {
  var urlparameter = defaultvalue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }
  return urlparameter;
}

function blurScore(inputImgTensor) {
  let _grayscaleFrame = inputImgTensor
    .mean(2)
    .toFloat()
    .expandDims(0)
    .expandDims(-1);
  let laplaceFilter = tf
    .tensor2d([
      [0, 1, 0],
      [1, -4, 1],
      [0, 1, 0],
    ])
    .expandDims(-1)
    .expandDims(-1);
  //const filter = tf.tensor2d([0, 1, 0, 1, 0, 1, 0, 1, 0], [3, 3])//.expandDims(0).expandDims(-1) // input filter 2d

  // get laplacian
  let _laplacian = _grayscaleFrame.conv2d(laplaceFilter, 1, "valid").squeeze();
  //console.log("Laplacian of inputImgTensor:")
  //console.log(_laplacian)

  var lap_mean = _laplacian.square().mean();
  var lap_variance = _laplacian.sub(lap_mean).square().mean();

  //ole.log("Variance of laplacian: ")
  //console.log(lap_variance)

  var blurScore = lap_variance.dataSync();
  lap_mean.dispose();
  _laplacian.dispose();
  lap_variance.dispose();
  _grayscaleFrame.dispose();
  laplaceFilter.dispose();
  return blurScore;
}

function calculateMouthOpenness(landmarksArray) {
  var xDistance = 0,
    yDistance = 0;
  let topX = 0,
    topY = 0,
    bottomX = 0,
    bottomY = 0;
  let currentTopIndex = 0,
    currentBottomIndex = 0;
  for (var c = 0; c < MOUTH_TOP.length; c++) {
    currentTopIndex = MOUTH_TOP[c];
    currentBottomIndex = MOUTH_BOTTOM[c];
    topX = landmarksArray[currentTopIndex][0];
    //topY = landmarksArray[currentTopIndex][1];
    bottomX = landmarksArray[currentBottomIndex][0];
    //bottomY = landmarksArray[currentBottomIndex][0];
    xDistance += Math.abs(topX - bottomX);
    //yDistance += Math.abs(topY-bottomY);
  }

  xDistance /= MOUTH_TOP.length;
  //yDistance /= MOUTH_TOP.length;
  //console.log("Lips X distance = " + xDistance); //+ " Y distance = " + yDistance)
  return xDistance; //{mouthXDifference:xDistance, mouthYDifference:yDistance}
}

function getMedian(arr) {
  const sorted = arr.slice().sort((a, b) => {
    return a - b;
  });
  if (sorted.length % 2 === 0) {
    const first = sorted[sorted.length / 2 - 1];
    const second = sorted[sorted.length / 2];
    return (first + second) / 2;
  } else {
    const mid = Math.floor(sorted.length / 2);
    return sorted[mid];
  }
}

function rejectOutliers(scores) {
  let intermediate = [];
  let any25 = false;

  for (var i = 0; i < scores.length; i++) {
    if (scores[i] < 7) {
      any25 = true;
      intermediate.push(scores[i]);
    }
  }
  if (any25) {
    return removeOutliersByMedian(intermediate);
  } else {
    return removeOutliersByMedian(scores);
  }
}

function removeOutliersByMedian(scores) {
  const rawMedian = getMedian(scores);
  let d = [];
  let currentVal = 0;
  let output = [];
  for (var i = 0; i < scores.length; i++) {
    currentVal = Math.abs(scores[i] - rawMedian);
    d.push(currentVal);
  }
  let mdev = getMedian(d);
  for (var i = 0; i < d.length; i++) {
    currentVal = d[i] / mdev;
    if (isNaN(currentVal)) {
      continue;
    }

    if (currentVal < 2) {
      output.push(scores[i]);
    }
  }

  return output;
}

function calculateHeadRotation(landmarksArray) {
  let horizontal0 = landmarksArray[horizonalLandmarks[0]],
    horizontal1 = landmarksArray[horizonalLandmarks[1]],
    vertical0 = landmarksArray[verticalLandmarks[0]],
    vertical1 = landmarksArray[verticalLandmarks[1]];

  let centerX = 0,
    centerY = 0;

  for (var c = 0; c < centerCoordinates.length; c++) {
    centerX += landmarksArray[centerCoordinates[c]][0];
    centerY += landmarksArray[centerCoordinates[c]][1];
  }
  centerX = centerX / centerCoordinates.length;
  centerY = centerY / centerCoordinates.length;

  var verticalAngleRadians = Math.atan2(
      vertical0[1] - vertical1[1],
      vertical0[0] - vertical1[0]
    ),
    horizontalAngleRadians = Math.atan2(
      horizontal0[1] - horizontal1[1],
      horizontal0[0] - horizontal1[0]
    ),
    zX =
      Math.abs(horizontal0[0] - centerX) / Math.abs(horizontal1[0] - centerX),
    zY = Math.abs(vertical0[1] - centerY) / Math.abs(vertical1[1] - centerY);

  var out = {
    horizontal: horizontalAngleRadians,
    vertical: verticalAngleRadians,
    zX: zX,
    zY: zY,
  };
  //console.log(out)

  return out;
}

function sendErrorlog(error, sourceLine) {
  console.log(error);
  console.log("At line: " + sourceLine);
  let errorURL =
    "https://9apw25ywc8.execute-api.eu-west-1.amazonaws.com/default/privately-error-logs";

  let deviceInformation =
    navigator.userAgent || navigator.vendor || window.opera;
  /*this.isRecordingScreen = false;
    this.isPermissionBlockedScreen = true;*/
  var errorOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  };
  errorOptions["body"] = JSON.stringify({
    error: "" + error,
    sourceLine: sourceLine,
    deviceInfo: deviceInformation,
  });

  fetch(errorURL, errorOptions)
    .then(async (response) => {})
    .catch((error2) => {
      console.log("Error in sendErrorlog() ", error2);
      /*this.isRecordingScreen = false;
                this.isPermissionBlockedScreen = true;*/
    });
}

function drawCanvas(canvas, img) {
  let ratio = Math.min(canvas.width / img.width, canvas.height / img.height);
  let x = (canvas.width - img.width * ratio) / 2;
  let y = (canvas.height - img.height * ratio) / 2;
  canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
  canvas
    .getContext("2d")
    .drawImage(
      img,
      0,
      0,
      img.width,
      img.height,
      x,
      y,
      img.width * ratio,
      img.height * ratio
    );
}

function Mutex() {
  let current = Promise.resolve();
  this.lock = () => {
    let _resolve;
    const p = new Promise((resolve) => {
      _resolve = () => resolve();
    });
    // Caller gets a promise that resolves when the current outstanding
    // lock resolves
    const rv = current.then(() => _resolve);
    // Don't allow the next request until the new promise is done
    current = p;
    // Return the new promise
    return rv;
  };
}

const mutex = new Mutex();
const takePhotoMutex = new Mutex();

async function estimateAndStoreFaces(
  video,
  snapshotCanvas,
  displayImageItem,
  imageItem,
  tensorImg,
  returnTensors,
  flipHorizontal,
  intervalID,
  that
) {
  var root_mean_squared_brightness = tensorImg.mean(2).square().mean().sqrt();
  var guidance_brightness_synced = root_mean_squared_brightness.dataSync()[0];

  var blurOrBrightnessIssues = false;
  if (guidance_brightness_synced <= BRIGHTNESS_GUIDANCE_LOWER_LIMIT) {
    that.videoOverlayText = tooDarkMessage;
    blurOrBrightnessIssues = true;
  }

  if (blurOrBrightnessIssues) {
    delayBecauseOfDistance += 2 * DELAY_INCREMENT_FOR_DISTANT_FACE;
    that.drawFaceCanvas(false);
    takePhotoUnlock();
    return;
  }

  let predictions = await blink_model.estimateFaces({
    input: tensorImg,
    returnTensors: returnTensors,
    flipHorizontal: flipHorizontal,
    predictIrises: false,
  });

  tf.engine().startScope();

  if (predictions.length > 0) {
    var faceTaken = false;
    countDownFactor += 1.0 / images_per_second;
    if (countDownFactor >= 1) {
      that.imageProcessCounter -= 1;
      countDownFactor = 0;
    }

    predictions.forEach(async (prediction, index) => {
      //console.log(prediction);
      const takePhotoUnlock = await takePhotoMutex.lock();
      tf.engine().startScope();
      if (
        index > 0 ||
        faceTaken ||
        that.imageItems.length > total_frames_to_analyze ||
        prediction.faceInViewConfidence < face_confidence_limit
      ) {
        try {
          //tf.engine().endScope()
          prediction = null;
        } catch (deadOnArrivalError) {
          console.log(
            "Tried to end scope for a prediction that will not be used"
          );
        }
        takePhotoUnlock();
        return;
      }
      const [x1, y1] = prediction.boundingBox.topLeft; //prediction.topLeft;
      const [x2, y2] = prediction.boundingBox.bottomRight; //prediction.bottomRight;
      const crop_area = Math.abs(y1 - y2) * Math.abs(x1 - x2);
      const whole_area = tensorImg.shape[0] * tensorImg.shape[1]; //video.videoWidth*video.videoHeight
      const percentage = (crop_area * 1.0) / whole_area;

      var tooFar = percentage <= minimum_face_percent;
      var tooClose = percentage > maximum_face_percent;

      let headRotationEstimate = null;
      let mouthOpennessEstimate = null;
      let face_straight = false;
      if (prediction.faceInViewConfidence > face_confidence_limit) {
        faceTaken = true;
        headRotationEstimate = calculateHeadRotation(prediction.scaledMesh);

        face_straight =
          headRotationEstimate.zX < left_rotation_threshold && // Turned left or right
          headRotationEstimate.zX > right_rotation_threshold &&
          headRotationEstimate.horizontal < tilt_right_threshold && // Tilted right or left
          headRotationEstimate.horizontal > tilt_left_threshold &&
          headRotationEstimate.zY > up_rotation_threshold && // Tilted up or down
          headRotationEstimate.zY < down_rotation_threshold;

        mouthOpennessEstimate = calculateMouthOpenness(prediction.mesh);

        var is_mouth_open = mouthOpennessEstimate >= MOUTH_X_OPEN_LIMIT;
        var is_mouth_closed = mouthOpennessEstimate <= MOUTH_X_CLOSED_LIMIT;

        if (is_mouth_open) {
          currentTimesMouthOpen += 1;
        }

        if (
          !mouth_already_opened &&
          currentTimesMouthOpen >= TIMES_MOUTH_NEEDS_TO_OPEN
        ) {
          mouth_already_opened = is_mouth_open;
          //console.log("Did mouth already open? " + mouth_already_opened);
        } else {
          mouth_already_closed = is_mouth_closed;
          //console.log("Did mouth already close? " + mouth_already_closed);
        }
      } else {
        takePhotoUnlock();
        return;
      }

      if (!mouth_already_opened || !mouth_already_closed) {
        // if we have already taken the first frame (close enough, good orientation), then we check for mouth movements
        if (!mouth_already_opened) {
          that.drawFaceCanvas(false);
          that.videoOverlayText =
            "One-time check: Please open and then close your mouth";
        } else if (!mouth_already_closed) {
          that.drawFaceCanvas(false);
          that.videoOverlayText = "You can close your mouth now";
          previouslyTooDistant = true;
          delayBecauseOfDistance += DELAY_INCREMENT_FOR_DISTANT_FACE;
        }
      } else if (tooFar || tooClose) {
        delayBecauseOfDistance += DELAY_INCREMENT_FOR_DISTANT_FACE;
        that.drawFaceCanvas(false);

        //delayBecauseOfDistance += DELAY_INCREMENT_FOR_DISTANT_FACE;
        // turned_left && turned_right &&
        if (that.showFaceFrame) {
          that.videoOverlayText = tooFar
            ? "Come Closer to Fit Your Face"
            : "Distance to Fit Your Face";
        } else {
          that.videoOverlayText = tooFar ? tooFarMsg : tooCloseMsg; // that.showFaceFrame ? keepFaceInFrame:
        }
        if (that.showFaceFrame) {
          faceframe_drawn = false;
        }
        previouslyTooDistant = true;
      } else if (!face_straight) {
        delayBecauseOfDistance += DELAY_INCREMENT_FOR_SUCCESSFUL; //DELAY_INCREMENT_FOR_DISTANT_FACE;
        that.drawFaceCanvas(false);
        if (prediction.faceInViewConfidence > face_confidence_limit) {
          if (headRotationEstimate.zX >= left_rotation_threshold) {
            // too much left
            that.videoOverlayText = correctFaceToRight;
          } else if (headRotationEstimate.zX <= right_rotation_threshold) {
            // too much right
            that.videoOverlayText = correctFaceToLeft;
          } else if (headRotationEstimate.zY <= up_rotation_threshold) {
            // too much up
            that.videoOverlayText = correctFaceToDown;
          } else if (headRotationEstimate.zY >= down_rotation_threshold) {
            // too much down
            that.videoOverlayText = correctFaceToUp;
          } else if (headRotationEstimate.horizontal >= tilt_right_threshold) {
            // tilted too right
            that.videoOverlayText = correctFaceTiltLeft;
          } else if (headRotationEstimate.horizontal <= tilt_left_threshold) {
            // tilted too left
            that.videoOverlayText = correctFaceTiltRight;
          } else {
            //console.log("Checking the head rotation estimates...")
            that.videoOverlayText = straightFaceMsg;
          }
        } else {
          that.videoOverlayText = straightFaceMsg;
        }
      } else if (!tooFar && !tooClose) {
        that.videoOverlayText = instructionMsg;

        that.drawFaceCanvas(true);
        that.showFaceFrame = true;
        var imgToInsert = imageItem;
        var local_canvas = null;
        try {
          if (imageCaptureDevice != null && index == 0) {
            var currentBlob = await imageCaptureDevice.takePhoto();
            var imageBitmap = await createImageBitmap(currentBlob);
            currentBlob = null;
            local_canvas = document.createElement("canvas");

            local_canvas.width = imageBitmap.width; //video.videoWidth;
            local_canvas.height = imageBitmap.height; //video.videoHeight;

            drawCanvas(local_canvas, imageBitmap);
            imgToInsert = local_canvas
              .getContext("2d")
              .getImageData(0, 0, local_canvas.width, local_canvas.height);

            if (!that.snapshotTaken && index == 0) {
              var croppedURLItem = local_canvas.toDataURL("image/jpeg");
              that.cropped_faces.push(croppedURLItem);
              that.imageResults.push({ img: croppedURLItem });
              that.snapshotTaken = true;
            }
          }
        } catch (takePhotoException) {
          console.log("TakePhotoException:", takePhotoException);
          takePhotoUnlock();
          return;
        }

        if (previouslyTooDistant) {
          previouslyTooDistant = false;
        } else {
          that.imageItems.push(imgToInsert);
          first_frame_before_mouth = true;
          that.progressValue =
            100 * ((that.imageItems.length * 1.0) / total_frames_to_analyze);
        }

        const fframe_keypoints = prediction.scaledMesh;

        var overlayCanvasDesktop = document.getElementById("overlayDesktop");
        var overlayCanvasMobile = document.getElementById("overlayMobile");

        if (overlayCanvasDesktop != null || overlayCanvasMobile != null) {
          var window_width_offset = (window.innerWidth - video.offsetWidth) / 3;

          if (overlayCanvasDesktop != null) {
            overlayCanvasDesktop.width = 640;
            overlayCanvasDesktop.height = 480;
            overlayCanvasDesktop.marginLeft = "auto";
            overlayCanvasDesktop.marginRight = "auto";
          }

          if (overlayCanvasMobile != null) {
            overlayCanvasMobile.width = window.innerWidth;
            overlayCanvasMobile.height = window.innerHeight;
          }

          that.marginLeft = window_width_offset + "px";
          var widthRatio = video.offsetWidth / video.videoWidth,
            heightRatio = video.offsetHeight / video.videoHeight;

          var ctx =
            overlayCanvasDesktop == null
              ? overlayCanvasMobile.getContext("2d")
              : overlayCanvasDesktop.getContext("2d");

          ctx.fillStyle = FACE_FRAME_COLOR;
          ctx.strokeStyle = FACE_FRAME_COLOR;
          ctx.lineWidth = 0.5;

          ctx.fillStyle = FACE_FRAME_COLOR;

          for (
            let i = 0;
            i < SILHOUETTE_KEYPOINTS.length /*NUM_KEYPOINTS*/;
            i++
          ) {
            const x =
              overlayCanvasDesktop != null
                ? fframe_keypoints[SILHOUETTE_KEYPOINTS[i]][0]
                : fframe_keypoints[SILHOUETTE_KEYPOINTS[i]][0] *
                  (widthRatio + 0.05);
            const y =
              overlayCanvasDesktop != null
                ? fframe_keypoints[SILHOUETTE_KEYPOINTS[i]][1]
                : fframe_keypoints[SILHOUETTE_KEYPOINTS[i]][1] *
                  (heightRatio + 0.05);
            ctx.beginPath();
            ctx.arc(x, y, 3 /* radius */, 0, 2 * Math.PI);
            ctx.fill();
          }

          const left_eye_center_x =
              (fframe_keypoints[leftEye_l][0] +
                fframe_keypoints[leftEye_r][0] +
                fframe_keypoints[leftEye_t][0] +
                fframe_keypoints[leftEye_b][0]) /
              4,
            left_eye_center_y =
              (fframe_keypoints[leftEye_l][1] +
                fframe_keypoints[leftEye_r][1] +
                fframe_keypoints[leftEye_t][1] +
                fframe_keypoints[leftEye_b][1]) /
              4,
            right_eye_center_x =
              (fframe_keypoints[rightEye_l][0] +
                fframe_keypoints[rightEye_r][0] +
                fframe_keypoints[rightEye_t][0] +
                fframe_keypoints[rightEye_b][0]) /
              4,
            right_eye_center_y =
              (fframe_keypoints[rightEye_l][1] +
                fframe_keypoints[rightEye_r][1] +
                fframe_keypoints[rightEye_t][1] +
                fframe_keypoints[rightEye_b][1]) /
              4;

          ctx.beginPath();
          ctx.arc(
            overlayCanvasDesktop != null
              ? left_eye_center_x
              : left_eye_center_x * (widthRatio + 0.05),
            overlayCanvasDesktop != null
              ? left_eye_center_y
              : left_eye_center_y * (heightRatio + 0.05),
            3 /* radius */,
            0,
            2 * Math.PI
          );
          ctx.fill();

          ctx.beginPath();
          ctx.arc(
            overlayCanvasDesktop != null
              ? right_eye_center_x
              : right_eye_center_x * (widthRatio + 0.05),
            overlayCanvasDesktop != null
              ? right_eye_center_y
              : right_eye_center_y * (heightRatio + 0.05),
            3 /* radius */,
            0,
            2 * Math.PI
          );
          ctx.fill();

          faceframe_drawn = true;
          //console.log("FaceFrame drawn!")
          that.showFaceFrame = true;
        }

        if (!that.snapshotTaken && imageCaptureDevice == null) {
          var croppedURLItem = snapshotCanvas.toDataURL("image/jpeg");
          that.cropped_faces.push(croppedURLItem);
          that.imageResults.push({ img: croppedURLItem });

          that.snapshotTaken = true;
        }
        //
      } // if (percentage <= minimum_face_percent)
      else {
        that.videoOverlayText =
          closed_eyes_detected && open_eyes_detected
            ? tooFar
              ? tooFarMsg
              : tooCloseMsg
            : blinkMsg;
        previouslyTooDistant = true;
        //console.log("Person got too far")
      }
      try {
        tf.engine().endScope();
      } catch (errorLib) {
        console.log("Did not end scope in async face predict");
      }
      takePhotoUnlock();
    });

    if (that.imageItems.length >= total_frames_to_analyze) {
      window.clearInterval(intervalID);
      that.isRecording = false;
      try {
        //console.log("Partial experience")
        that.fallback_predict(that.imageItems, null); //audioBuffer)
      } catch (error) {
        sendErrorlog(error, "Prediction Step in Fallback mode");
        //brightEnough = false;
      }

      try {
        blink_model = null;
        tf.engine().endScope();
      } catch (activeScopeError) {
        console.log("Active scope was not available");
      }
      //that.stopRecording()
    }
  } else {
    console.log("Blazeface reports: no faces detected...");
    imageItem = null;
    //processedFaceTensor = tensorImg;
  }

  tensorImg.dispose();
  //predictions.dispose()
  try {
    tf.engine().endScope();
    //console.log("Ended the scope")
  } catch (scopeError) {
    console.log("Active scope null");
  }
}

var resultPresented = new Boolean(false);

export default {
  data() {
    return {
      videoReady: false,
      dynamicVideoWidth: 0,
      dynamicVideoHeight: 0,
      dynamicAspectRatio: 0,
      shouldApplyLeftCenter: false,
      mediaStreamForDesktop: null,
      isFaceStill: false,
      disclaimerAgreed: false,
      disclaimerChecked: false,
      calculatedVideoWidth: 320,
      calculatedVideoHeight: 240,
      arcoscan_overlay: require("@/assets/images/arcoscan/overlay_new.svg"),
      still_img: require("@/assets/images/arcoscan/overlay_new.svg"),
      nonstill_img: require("@/assets/images/arcoscan/overlay_new.svg"),
      still_img_mobile: require("@/assets/images/arcoscan/overlay_new_mobile.svg"),
      nonstill_img_mobile: require("@/assets/images/arcoscan/overlay_new_mobile.svg"),
      failed_image: false,
      isMobile: false,
      isSupported: true,
      isRecording: false,
      audioStopped: false,
      audioData: "",
      language: "English",
      text: "",
      loading: true,
      displayResult: false,
      recordingButtonString: "Begin Recording",
      imageProcessCounter: 5,
      imageProcessRunning: false, // it was false
      modelDownloading: true,
      overallResult: "",
      overallConfidence: 0,
      imageItems: [],
      imageResults: [],
      cropped_faces: [],
      snapshotTaken: false,
      processed_face_tensors: [],
      face_tensors_for_anti_spoofing: [],
      face_frame_image_data: [],
      recordedChunks: [],
      imageLabels: [],
      imageConfidence: [],
      audioRecorder: null,
      audioResultLabel: undefined,
      audioResultConfidence: undefined,
      videoOverlayText:
        "Be in a **well-lit** room, remove mask and respond slowly to the instructions", //  align your eyes to camera &
      showFaceFrame: false,
      videoOverlayPosition: "33%",
      videoOverlayPositionMobile: "65%",
      faceMaskOverlayPosition: "8%",
      marginLeft: "0px",
      progressBarOptions: "",
      progressValue: 0,
      constraints: {
        video: true,
      },
      isChoiceScreen: true, //BROKEN was true
      isRecordingScreen: false, //BROKEN was false
      isResultScreen: false,
      isPermissionBlockedScreen: false,
      COPY: {
        NOT_SUPPORTED_SCREEN: {
          TITLE: "We do not support your device-browser pair",
          BODY: "Optimized for Chrome and Firefox to work on Windows, Linux, MacOS, Android and iOS environments, with the exception of Firefox on Android.",
        },
        CHOICE_SCREEN: {
          TITLE: "Welcome",
          DESCRIPTION:
            "This demo records a short video and estimates your age. Note that anti-spoof measures are not in place. Please press the button below to start, and follow the instructions to correctly position your face",
          I_AGREE: "I agree to let Arcoscan process my data for this service.",
          BUTTON_TEXT: "Start",
        },
        LOADING_SCREEN: {
          TEXT: "Preparing your privacy-preserving age estimation test, please wait...",
        },
        PERMISSION_BLOCKED_SCREEN: {
          BODY: "Please re-enable access to microphone and camera &amp; refresh your browser in order to proceed. Make sure that you do not have another browser or application using your camera or microphone. Alternatively, try accessing the site with another browser.",
          TITLE: "ARCOSCAN",
          SUBTITLE: "We can’t access your camera or microphone",
        },
      },
    };
  },
  created() {
    try {
      if (sessionStorage.getItem("disclaimer") == "agreed") {
        this.disclaimerAgreed = true;
      } else {
        this.disclaimerAgreed = false;
      }
      sessionStorage.setItem("disclaimer", "notagreed");
    } catch (e) {
      if (e.name === "SecurityError") {
        // Session Storage not available
        this.disclaimerAgreed = false;
      } else {
        throw e;
      }
    }

    var is_internet_explorer = detectIE();

    if (!is_internet_explorer) {
    } else {
      this.isSupported = false;
      this.isChoiceScreen = false;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeVideo);
  },
  mounted() {
    console.log("enter mounted");
    // const video = document.getElementById("mobileVideo");
    // video.addEventListener(
    //   "loadeddata",
    //   function () {
    //     this.videoReady = true;
    //   },
    //   false
    // );

    var userAgent = window.navigator.userAgent;

    this.isMobile =
      navigator.userAgent.indexOf("Mobile") != -1 || userAgent.match(/iPhone/i);
    var is_firefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    var is_apple = navigator.vendor.toLowerCase().indexOf("apple") == -1;
    var is_internet_explorer = detectIE();

    //var is_android = navigator.platform.toLowerCase().indexOf("android") > -1;
    this.isFirefoxOnAndroid = is_firefox && this.isMobile && !is_apple; //is_android // navigator.vendor.indexOf("Apple") == -1 &&
    // console.log(this.isMobile)
    // this.isFirefoxOnAndroid ||
    if (is_internet_explorer) {
      //navigator.vendor.indexOf("Apple") != -1 && navigator.userAgent.indexOf("Mobile") != -1){
      this.isSupported = false;
      this.isChoiceScreen = false;
    }

    if (this.isMobile) {
      total_frames_to_analyze = 5;
      images_per_second = 5;
    }

    var isChromium = window.chrome;
    var winNav = window.navigator;
    var vendorName = winNav.vendor;
    var isOpera = typeof window.opr !== "undefined";
    var isIEedge = winNav.userAgent.indexOf("Edg") > -1;
    var isIOSChrome = winNav.userAgent.match("CriOS");
    var isLaptopChome = false;
    if (isIOSChrome) {
      // is Google Chrome on IOS
      console.log("Google Chrome on IOS");
    } else if (
      isChromium !== null &&
      typeof isChromium !== "undefined" &&
      vendorName === "Google Inc." &&
      isOpera === false &&
      isIEedge === false
    ) {
      // is Google Chrome
      console.log("Is Google Chrome");
      isLaptopChome = true;
    } else {
      console.log("Not Google Chrome");
      // not Google Chrome
    }

    // console.log("is_apple", is_apple);
    // console.log("mobile", this.isMobile);
    // console.log("isLaptopChome", isLaptopChome);

    setTimeout(() => {
      tf.setBackend("wasm")
        .then(() => {
          this.initialize();
          1 / 0;
        }) //BROKEN
        .catch((error) => {
          console.log("Could not set the WASM backend ", error);
          this.isRecordingScreen = false;
          this.isPermissionBlockedScreen = true;
        });
    }, 500);

    if (!this.isMobile) {
      this.resizeVideo();
      window.addEventListener("resize", this.resizeVideo);
    }
  },
  components: { Task, Infobox },
  computed: {
    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "400px";
        case "sm":
          return "500px";
        case "md":
          return "684px";
        case "lg":
          return "684px";
        case "xl":
          return "684px";
      }
    },
    headerAsset() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return require("@/assets/images/arcoscan/header_mobile_new.png");
        case "sm":
          return require("@/assets/images/arcoscan/header_mobile_new.png");
        case "md":
          return require("@/assets/images/arcoscan/header.png");
        case "lg":
          return require("@/assets/images/arcoscan/header.png");
        case "xl":
          return require("@/assets/images/arcoscan/header.png");
      }
    },
    dynamicVideoStyle() {
      return {
        width: `${this.dynamicVideoWidth * 0.7}px`,
        height: `${this.dynamicVideoHeight * 0.7}px`,
      };
    },
    ...mapGetters("labeling", {}),
    ...mapGetters("common", {
      pageElements: "pageElements",
      interactInfos: "interactInfos",
    }),
    languages() {
      if (this.$route.name === "hate_toxicity") {
        return ["English", "French", "German - Swiss German", "Swiss German"];
      } else {
        return ["English"];
      }
    },
    _() {
      return _;
    },
    icon() {
      return "";
    },
    cPicture: function () {
      return this.failed_image
        ? "https://picsum.photos/500/300?image=4"
        : this.imageResults[0];
    },
  },
  methods: {
    onImgError: function (event) {
      console.log("Failed to load image, now will put another image");
      this.failed_image = true;
    },
    async setupMediaStream() {
      const constraints = {
        video: {
          width: { ideal: this.dynamicVideoWidth },
          height: { ideal: this.dynamicVideoHeight },
          aspectRatio: this.dynamicVideoWidth / this.dynamicVideoHeight,
        },
      };

      try {
        this.mediaStreamForDesktop = await navigator.mediaDevices.getUserMedia(
          constraints
        );

        if (this.$refs.video) {
          this.$refs.video.srcObject = this.mediaStreamForDesktop;
        }
      } catch (error) {
        console.error("Error accessing camera:", error);
      }
    },
    resizeVideo() {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      if (windowWidth <= 768) {
        this.shouldApplyLeftCenter = true;
        const mobileAspectRatio = 0.75;
        this.dynamicAspectRatio = mobileAspectRatio;
        if (windowWidth / windowHeight > mobileAspectRatio) {
          this.dynamicVideoWidth = windowWidth;
          this.dynamicVideoHeight = windowWidth / mobileAspectRatio;
        } else {
          this.dynamicVideoWidth = windowHeight * mobileAspectRatio;
          this.dynamicVideoHeight = windowHeight;
        }
        this.arcoscan_overlay = this.still_img_mobile;
      } else {
        this.shouldApplyLeftCenter = false;
        const desiredAspectRatio = 16 / 9;
        this.dynamicAspectRatio = desiredAspectRatio;
        if (windowWidth / windowHeight > desiredAspectRatio) {
          this.dynamicVideoWidth = windowHeight * desiredAspectRatio;
          this.dynamicVideoHeight = windowHeight;
        } else {
          this.dynamicVideoWidth = windowWidth;
          this.dynamicVideoHeight = windowWidth / desiredAspectRatio;
        }
        this.arcoscan_overlay = this.still_img;
      }
      if (!this.isMobile) {
        this.setupMediaStream();
      }
    },
    tryAgain() {
      this.disclaimerAgreed = true;
      for (var i = 0; i < this.processed_face_tensors.length; i++) {
        try {
          this.processed_face_tensors[i].dispose();
        } catch (error) {
          console.log("Could not dispose of the tensors:");
          console.log(error);
        }
      }

      for (var i = 0; i < this.face_tensors_for_anti_spoofing.length; i++) {
        try {
          this.face_tensors_for_anti_spoofing[i].dispose();
        } catch (error) {
          console.log("Could not dispose of the tensors:");
          console.log(error);
        }
      }

      if (this.transaction_id != null && !this.estimationCompleted) {
        // Report that there was an incomplete estimation
        var reportingRequestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        };

        reportingRequestOptions["body"] = JSON.stringify({
          request_type: "complete_transaction",
          transaction_id: this.transaction_id,
          api_key: getUrlParam("api_key", null),
          api_secret: getUrlParam("api_secret", null),
          browser_response_data: {
            age: "Unsuccessful test",
            age_confidence: 0,
            genuineness: 0,
            product: "age",
            modality: "image",
          },
        });
        fetch(this.reportingURL, reportingRequestOptions).then(
          async (response) => {
            console.log("Incomplete transaction has been logged");
          }
        );
      }

      this.failed_image = false;
      this.resultPresented = false;
      this.isResultScreen = false;
      this.isRecordingScreen = true;
      this.imageProcessCounter = 5;
      this.audioStopped = false;
      this.imageResults = [];
      this.cropped_faces = [];
      this.processed_face_tensors = [];
      this.face_tensors_for_anti_spoofing = [];
      open_eyes_detected = true; //this.isMobile // assume the blink test pass for mobile devices
      //open_eyes_detected_2=false
      closed_eyes_detected = true; //this.isMobile // assume the blink test pass for mobile devices
      //closed_eyes_detected_2=false
      only_one_face = true;
      this.snapshotTaken = false;
      this.videoOverlayText =
        "Be in a **well-lit** room, remove mask and respond slowly to the instructions"; //  align your eyes to camera &

      this.recordedChunks = [];
      this.imageItems = [];
      this.estimationCompleted = false;
      tf.disposeVariables();
      test_id = test_id + 1;
      if (test_id >= maximum_test_count) {
        window.location.reload();
        return;
      }
    },
    reloadVideo() {
      return "Hello";
      // this.tryAgain()
    },
    clearText() {
      this.text = "";
    },
    retryPermissions() {
      this.isPermissionBlockedScreen = false;
      this.isChoiceScreen = true;
    },
    drawFaceCanvas(isActive) {
      var faceOverlayCanvas, ctx;

      try {
        if (this.isRecordingScreen) {
          if (this.isMobile) {
            this.isFaceStill = isActive;
            var video = document.querySelector("video");
            this.calculatedVideoWidth = video.offsetWidth;
            this.calculatedVideoHeight = video.offsetHeight;
          } else {
            //since the video size is fixed for desktop, canvas rendering is used (just for the heck of it)
            faceOverlayCanvas = document.getElementById("faceOverlay");
            ctx = faceOverlayCanvas.getContext("2d");
            var overlayImg = new Image();
            var thisthat = this;
            overlayImg.onload = function () {
              faceOverlayCanvas.width = thisthat.initialVideoWidth;
              faceOverlayCanvas.height = thisthat.initialVideoHeight;
              // console.log("INITIAL VIDEO WIDTH:::", thisthat.initialVideoWidth);
              // console.log("INITIAL VIDEO HEIGHT:::", thisthat.initialVideoHeight);

              ctx.drawImage(
                overlayImg,
                0,
                0,
                thisthat.initialVideoWidth,
                thisthat.initialVideoHeight
              );
            };
            overlayImg.src = this.arcoscan_overlay;
            // console.log("overlayimmmmmgg:", overlayImg);
          }
        }
      } catch (faceCanvasDrawError) {
        console.log("Face canvas not drawn anymore");
      } finally {
        // nothing else to do
      }
    },
    startVideo() {
      this.isChoiceScreen = false;
      this.isRecordingScreen = true;
      this.imageProcessCounter = 5;

      var ua = window.navigator.userAgent;
      var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      var webkit = !!ua.match(/WebKit/i);
      var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

      let recordingConstraintsForDesktop = {
        audio: false,
        video: {
          facingMode: "user",
          //aspectRatio: this.dynamicAspectRatio,
        },
      };

      //let aspectRatio1 = iOSSafari ? 0.749 : 1.33;
      let height1 = !iOSSafari
        ? { min: 320, ideal: 480, max: 480 }
        : { min: 426, ideal: 572, max: 572 };
      let width1 = !iOSSafari
        ? { min: 426, ideal: 640, max: 640 }
        : { min: 320, ideal: 429, max: 429 };

      let recordingConstraintsForMobile = {
        audio: false,
        video: {
          height: height1,
          width: width1,
          aspectRatio: 1.33,
          facingMode: "user",
        },
      };

      let recordingConstraints = this.isMobile
        ? recordingConstraintsForMobile
        : recordingConstraintsForDesktop;
      if (this.hasGetUserMedia()) {
        navigator.mediaDevices
          .getUserMedia(recordingConstraints)
          .then((stream) => {
            this.drawFaceCanvas(false);
            //console.log("yes")
          });

        //console.log("Good To Go");
        var blazemodel_load_promise = blazeface.load();
        blazemodel_load_promise.then(async (blaze_promise_response) => {
          blazemodel = blaze_promise_response;
        });
        setTimeout(() => {
          //const canvas = document.createElement("canvas");

          navigator.mediaDevices
            .getUserMedia(recordingConstraints)
            .then((stream) => {
              const video = document.querySelector("video");
              video.srcObject = stream;
              //mediaStream)

              if (!this.isMobile) {
                gotMedia(stream, this.isMobile);
                //gotMedia(stream, this.isMobile)//mediaStream)
              }
              this.stream = stream;
              this.progressBarOptions = {
                progress: {
                  inverted: false,
                  color: "#1681FF",
                  backgroundColor: "#FFFFFF",
                },
                text: {
                  hideText: true,
                },
                layout: {
                  height: 16,
                  width: this.isMobile ? video.offsetWidth : 640,
                  zeroOffset: 0,
                  progressPadding: 0,
                  type: "line",
                },
              };
            })
            .then(
              () =>
                new Promise((resolve) =>
                  setTimeout(() => {
                    this.videoReady = true;
                    resolve();
                  }, 500)
                )
            )
            .catch((error) => {
              console.log("Error in StartVideo()->getUserMedia() ", error);
              console.log(error.name);
              this.isRecordingScreen = false;
              this.isPermissionBlockedScreen = true;
            });
        }, 500);
      } else {
        console.log("Errors Abound");
      }
    },
    hasGetUserMedia() {
      return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
    },
    onVideoStream(stream) {
      this.isRecording = true;
      this.$refs.video.srcObject = stream;
      resultPresented = false;
    },
    stopRecord() {
      (this.isRecordingScreen = false),
        // this.isResultScreen = true
        (this.isChoiceScreen = true);
    },
    get_iOS_version(deviceInformation) {
      if (/iP(hone|od|ad)/.test(deviceInformation)) {
        // navigator.platform
        // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
        try {
          var v = deviceInformation.match(/OS (\d+)_(\d+)_?(\d+)?/); // appVersion
          return [
            true,
            parseInt(v[1], 10),
            parseInt(v[2], 10),
            parseInt(v[3] || 0, 10),
          ];
        } catch (v1Error) {
          return [true, 1];
        }
      } else {
        // console.log("Probably not an iOS device");
        return [false, null];
      }
    },
    get_Android_version(deviceInformation) {
      // todo: fill the logic
      if (deviceInformation.match(/Android/i)) {
        try {
          var match = deviceInformation
            .toLowerCase()
            .match(/android\s([0-9\.]*)/i);
          // parseInt(getAndroidVersion(), 10); //4
          // parseFloat(getAndroidVersion()); //4.2
          return [true, parseInt(match ? match[1] : undefined, 10)];
        } catch (v1Error) {
          return [true, 1];
        }
      } else {
        // console.log("Probably not an Android device");
        return [false, null];
      }
    },
    getChromeVersion(deviceInformation) {
      var raw = deviceInformation.match(/C(hrome|riOS)\/([0-9]+)\./);

      return raw ? [true, parseInt(raw[2], 10)] : [false, null];
    },
    checkDeviceForFullCompatibility() {
      this.isMobile = navigator.userAgent.indexOf("Mobile") != -1;
      var is_firefox =
        navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
      var is_apple = navigator.vendor.toLowerCase().indexOf("apple") == -1;
      var is_internet_explorer = detectIE();
      let deviceInformation =
        navigator.userAgent || navigator.vendor || window.opera;
      // console.log(deviceInformation);
      // console.log("OS Version:");
      // console.log(navigator.oscpu);

      if (typeof navigator.oscpu === "undefined") {
        // console.log("Got undeclared variable");
      }

      let iOSVersion = this.get_iOS_version(deviceInformation);
      // console.log("iOS Version: ");
      // console.log(iOSVersion);

      let androidVersion = this.get_Android_version(deviceInformation);
      // console.log("Android Version: ");
      // console.log(androidVersion);

      let chromeVersion = this.getChromeVersion(deviceInformation);
      // console.log("Chrome Version: ");
      // console.log(chromeVersion);
      //var is_android = navigator.platform.toLowerCase().indexOf("android") > -1;
      this.isFirefoxOnAndroid = is_firefox && this.isMobile && !is_apple; //is_android // navigator.vendor.indexOf("Apple") == -1 &&
      // console.log(this.isMobile)
      // this.isFirefoxOnAndroid ||
      if (is_internet_explorer) {
        //navigator.vendor.indexOf("Apple") != -1 && navigator.userAgent.indexOf("Mobile") != -1){
        this.isSupported = false;
        this.isChoiceScreen = false;
      }

      if (this.isMobile) {
        total_frames_to_analyze = 5;
        images_per_second = 5;
      }

      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edg") > -1;
      var isIOSChrome =
        this.isMobile &&
        (deviceInformation.match("CriOS") || deviceInformation.match("Chrome"));
      var isLaptopChome = false;
      if (isIOSChrome) {
        // is Google Chrome on IOS
        // console.log("Google Chrome on IOS");
      } else if (
        isChromium !== null &&
        typeof isChromium !== "undefined" &&
        vendorName === "Google Inc." &&
        isOpera === false &&
        isIEedge === false
      ) {
        // is Google Chrome
        // console.log("Is Google Chrome");
        isLaptopChome = true;
      } else {
        // console.log("Not Google Chrome");
        // not Google Chrome
      }

      // console.log("is_apple", is_apple);
      // console.log("mobile", this.isMobile);
      // console.log("isLaptopChome", isLaptopChome);

      /* EXCLUSION LIST */
      let incompatible_apple =
        /*(deviceInformation.indexOf("CriOS/96.0.4664.53") < 0)*/ !isIOSChrome &&
        deviceInformation.indexOf("Mobile/15E148 Safari/604.1") >= 0;
      let unsupported_ios = iOSVersion[0] == true && iOSVersion[1] < 14; // 15
      let windows_mobile = /windows phone/i.test(deviceInformation);
      let samsung_browser = deviceInformation.indexOf("SamsungBrowser") >= 0;
      let unsupported_android =
        androidVersion[0] == true && androidVersion[1] < 11; // all below 11 will go
      let firefox_version_below_acceptable =
        deviceInformation.match(/Firefox\/([0-9]+)\./) &&
        parseInt(deviceInformation.match(/Firefox\/([0-9]+)\./)[1]) < 94;
      // console.log("firefox_version_below_acceptable = " + firefox_version_below_acceptable);
      let chrome_version_below_acceptable =
        chromeVersion[0] == true && chromeVersion[1] < 90;
      let edge_on_laptop = isIEedge && !this.isMobile;

      let must_exclude_conditions =
        unsupported_ios ||
        incompatible_apple ||
        windows_mobile ||
        samsung_browser ||
        unsupported_android ||
        chrome_version_below_acceptable ||
        firefox_version_below_acceptable ||
        edge_on_laptop;
    },
    recordingButton() {
      //this.checkDeviceForFullCompatibility()
      if (this.isRecording) {
        this.isRecording = false;
      } else {
        try {
          this.imageProcessRunning = true;
          this.isRecording = true;
          this.imageItems = [];
          this.imageURLItems = [];
          this.imageProcessCounter = 5; //"Get Ready!"//5

          closed_eyes_detected = true; //this.isMobile
          open_eyes_detected = true; // this.isMobile
          emotion_1_detected = true; //false
          emotion_2_detected = true; //false

          currentTimesMouthOpen = 0;

          var turned_right = true,
            turned_left = true,
            face_straight = false;

          mouth_already_opened = false;
          mouth_already_closed = false;
          first_frame_before_mouth = false;

          let randIndex_1 = Math.floor(
            Math.random() * FACE_EXPRESSION_LABELS.length
          );
          let randIndex_2 = Math.floor(
            Math.random() * FACE_EXPRESSION_LABELS.length
          );

          // console.log("Selecting random indices for expressions...");
          while (randIndex_2 == randIndex_1) {
            randIndex_2 = Math.floor(
              Math.random() * FACE_EXPRESSION_LABELS.length
            );
          }

          emotion_1 = FACE_EXPRESSION_LABELS[randIndex_1];
          emotion_2 = FACE_EXPRESSION_LABELS[randIndex_2];

          var emotion_msg_1 = "Please mimic as if you are feeling " + emotion_1,
            emotion_msg_2 = "Please mimic as if you are feeling " + emotion_2;

          //console.log("Will test " + emotion_1 + " and " + emotion_2);

          // if (!(closed_eyes_detected && open_eyes_detected)) {
          //   //!this.isMobile)
          //   console.log("Recording start on non-mobile device: blink detection enabled");
          // }
          if (!emotion_1_detected) {
            this.videoOverlayText = emotion_msg_1;
          } else if (!emotion_2_detected) {
            this.videoOverlayText = emotion_msg_2;
          }
          this.videoOverlayText = !(closed_eyes_detected && open_eyes_detected)
            ? blinkMsg
            : "Get Ready!"; //instructionMsg
          this.videoOverlayPosition = "15%";
          this.videoOverlayPositionMobile = "65%";
          //this.videoOverlayText = "Get Ready!"
          const video = document.querySelector("video");
          const canvas = document.createElement("canvas");

          window.AudioContext =
            window.AudioContext || window.webkitAudioContext;
          if (!navigator.getUserMedia)
            navigator.getUserMedia =
              navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
          if (!navigator.cancelAnimationFrame)
            navigator.cancelAnimationFrame =
              navigator.webkitCancelAnimationFrame ||
              navigator.mozCancelAnimationFrame;
          if (!navigator.requestAnimationFrame)
            navigator.requestAnimationFrame =
              navigator.webkitRequestAnimationFrame ||
              navigator.mozRequestAnimationFrame;

          const returnTensors = false;
          const flipHorizontal = true;
          const annotateBoxes = true;

          let that = this;
          var x = 0;
          var t = 0;

          var assess_frame = false;
          var record_for_prediction = false;

          //console.log("Waiting for blink_model load")
          while (blink_model == null) {
            // waiting...
          }
          //console.log("blink_model loaded")

          var myHeader = {
            mode: "no-cors",
            "Access-Control-Allow-Origin": "*",
          };

          tf.engine().startScope();
          var intervalID = window.setInterval(async function () {
            const unlock = await mutex.lock();
            if (this.imageProcessCounter != "Get Ready!") {
              record_for_prediction =
                t %
                  ((5 * images_per_second) / (2 * total_frames_to_analyze)) ===
                0;

              assess_frame =
                !face_straight ||
                !turned_right ||
                !turned_left ||
                (!emotion_1_detected && !emotion_2_detected) ||
                previouslyTooDistant ||
                !(closed_eyes_detected && open_eyes_detected) ||
                record_for_prediction;

              if (assess_frame) {
                if (delayBecauseOfDistance > 0) {
                  delayBecauseOfDistance -= 1;
                  //console.log("Delaying because of delayBecauseOfDistance = " + delayBecauseOfDistance)
                  unlock();
                } else {
                  //var imageItem = null;
                  //let tensorImg = null;
                  //console.log("Assessing frame...")
                  try {
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    canvas.getContext("2d").drawImage(video, 0, 0);
                  } catch (error) {
                    sendErrorlog(
                      error,
                      "While getting context and drawing image from the video"
                    );
                    this.isRecordingScreen = false;
                    this.isPermissionBlockedScreen = true;
                    unlock();
                    return;
                  }

                  var displayImageItem = null;
                  try {
                    displayImageItem = canvas
                      .getContext("2d")
                      .getImageData(0, 0, video.videoWidth, video.videoHeight);
                  } catch (getImageDataError) {
                    console.log(
                      "Could not capture image data at one moment. Reason: "
                    );
                    console.log(getImageDataError);
                    unlock();
                  }

                  if (displayImageItem != null) {
                    if (imageCaptureDevice == null) {
                      try {
                        // imageCaptureDevice
                        //var imageItem = canvas.toDataURL("image/jpeg");
                        var imageItem = displayImageItem;

                        //let tensorImg = tf.browser.fromPixels(imageItem).toFloat();
                        tf.engine().startScope();
                        let tensorImg = tf.browser
                          .fromPixels(displayImageItem)
                          .toFloat(); //tf.browser.fromPixels(imageItem).toFloat();

                        await estimateAndStoreFaces(
                          video,
                          canvas,
                          displayImageItem,
                          imageItem,
                          tensorImg,
                          returnTensors,
                          flipHorizontal,
                          intervalID,
                          that
                        ); // warning: this is async now!
                        displayImageItem = null;
                        imageItem = null;
                        unlock();
                        try {
                          tensorImg.dispose();
                        } catch (error) {
                          //console("Classic: tensorImg already disposed?")
                        }
                        try {
                          tf.engine().endScope();
                        } catch (error) {
                          //console.log("Classic: Could not end scope")
                        }
                        //console.log("Classic: Lock released")
                      } catch (error) {
                        //console.log("Could not continue", error)
                        unlock();
                        //console.log("Classic: Lock released after error")
                      }
                    } else {
                      tf.engine().startScope();
                      let tensorImg = tf.browser
                        .fromPixels(displayImageItem)
                        .toFloat();
                      try {
                        await estimateAndStoreFaces(
                          video,
                          null,
                          displayImageItem,
                          null,
                          tensorImg,
                          returnTensors,
                          flipHorizontal,
                          intervalID,
                          that
                        );
                        displayImageItem = null;
                      } catch (estimateFacesError) {
                        console.log("estimateFacesError:", estimateFacesError);
                      }
                      try {
                        tensorImg.dispose();
                      } catch (error) {
                        console("tensorImg already disposed?");
                      }
                      try {
                        tf.engine().endScope();
                      } catch (error) {
                        console.log("Could not end scope");
                      }
                      unlock();
                      //console.log("ImageCapture: Lock released")
                    }
                  } else {
                    // console.log("Unlocking because displayImageItem == null");
                    unlock();
                  }
                }
              }
            } else {
              delayBecauseOfDistance = 0;
              // console.log("delayBecauseOfDistance set to 0");
              unlock();
            }
            if (++t > total_seconds * images_per_second) {
              window.clearInterval(intervalID);
              that.isRecording = false;
              // console.log("Exceeded the time, will need to reset");
              alert(
                "Your age test has exceeded the time limit before we could sample a good number of images. Please follow the instructions to align your face and complete the test."
              );
              window.location.reload();
            }
          }, 1000 / images_per_second); // instead of 1000

          tf.engine().endScope();
        } catch (error) {
          sendErrorlog(error, "Main recordingButton()");
          alert(
            "Could not initiate the camera, we will have to restart. Sorry."
          );
          window.location.reload();
        }
      }
    },
    async initialize() {
      //console.log("INIT");

      this.estimationCompleted = false;

      let session_id = getUrlParam("session_id", null); //getUrlVars();
      if (session_id == null) {
        session_id = getUrlParam("api_key", null);
      }

      let session_password = getUrlParam("session_password", null); //getUrlVars();
      if (session_password == null) {
        session_password = getUrlParam("api_secret", null);
      }

      let transaction_id = getUrlParam("transaction_id", null);
      this.transaction_id = transaction_id;
      this.reportingURL =
        "https://wycmdhq5c2.execute-api.eu-west-1.amazonaws.com/default/d-privately-age-services";

      this.checkDeviceForFullCompatibility();

      if (session_id == null || session_password == null) {
        alert(
          "A session id and a session password required to perform estimation. Please contact the owner of the website you are visiting."
        );
        window.location.reload();
        return;
      }
      window.onerror = function (msg, src, linenum, colnum, error) {
        sendErrorlog(msg, src + " " + linenum);
      };
      offset = tf.scalar(127.5);
      brightness_lower_limit = tf.scalar(20);

      brightness_mid_limit = tf.scalar(149.0);
      brightness_upper_limit = tf.scalar(200);
      brightness_factor = tf.scalar(1);
      var blink_model_load_promise = faceLandmarksDetection.load(
        faceLandmarksDetection.SupportedPackages.mediapipeFacemesh,
        { maxFaces: 1, shouldLoadIrisModel: false }
      );

      let loginRequestsUrl =
        "https://wok2ltko9i.execute-api.eu-west-1.amazonaws.com/default/d-privately-cognito-communicator-python";

      var loginRequestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }, //
      };

      loginRequestOptions["body"] = JSON.stringify({
        execution_mode: "login_existing_user",
        session_id: session_id,
        session_password: session_password,
      });

      this.loginRequestOptions = loginRequestOptions;
      this.loginRequestsUrl = loginRequestsUrl;

      fetch(loginRequestsUrl, loginRequestOptions).then(async (response) => {
        const response_payload = await response.json();
        // console.log(response_payload);

        let myURL = "";
        let mySuffix = "?";
        try {
          //console.log(response_payload)
          let myObj = JSON.parse(response_payload[0]["body"]);
          //console.log(myObj)
          //console.log(myObj)
          myURL = myObj["url"];
          let creds = myObj["creds"];

          for (let key in creds) {
            //console.log(key, yourobject[key]);
            //setCookie(key, creds[key])
            mySuffix += key.replace("CloudFront-", "") + "=" + creds[key] + "&";
          }
          mySuffix = mySuffix.slice(0, -1);
          //console.log(mySuffix)
          this.mySuffix = mySuffix;
          //console.log(creds)
          this.myURL = myURL;
        } catch (error) {
          myURL =
            "Invalid session information. Please contact the owner of the website for more information";
          // console.log(myURL);
          window.alert(myURL);
          window.location.reload();
          return;
        }

        var myHeader = {
          //
          mode: "cors",
          "content-type": "application/json",
          "access-control-allow-methods": "GET, PUT, POST, DELETE, HEAD",
        };
        var myInit = { headers: myHeader };

        blink_model_load_promise.then(async (blink_promise_response) => {
          blink_model = blink_promise_response;
        });

        this.imageProcessCounter = 5;

        this.modelDownloading = false; //BROKEN NOW -- Should be false
      });
    },

    rotate(x, y, xm, ym, a) {
      var cos = Math.cos,
        sin = Math.sin;
      // a = a * Math.PI / 180, // Convert to radians
      // Subtract midpoints, so that midpoint is translated to origin
      // and add it in the end again

      let xr = (x - xm) * cos(a) + (y - ym) * sin(a) + xm;
      let yr = (y - ym) * cos(a) - (x - xm) * sin(a) + ym;

      return [xr, yr];
    },
    rotatePoint(point, center, a) {
      return this.rotate(point[0], point[1], center[0], center[1], a);
    },
    calculateMinMax(data) {
      var parsedData = data.map(Number);

      var minValue = Math.min(...parsedData);
      var maxValue = Math.max(...parsedData);

      return [minValue, maxValue];
    },
    async transmitdata(imageData) {
      var cleanStr = "data:image/jpeg;base64,";
      // console.log("data:audio/wav;base64," + this.audioData);
      let failed_count = 0;
      for (var i = 0; i < 5 && i < imageData.length; i++) {
        try {
          imageData[i] = imageData[i].replace(cleanStr, "");
        } catch (processException) {
          console.log("could not process this");
          failed_count++;
        }
      }

      if (failed_count > 0) {
      }
      var requestsUrl =
        "https://fallback-server-for-on-browser.privately.swiss";
      requestsUrl += "/margin/video-age-verification";
      var requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      };
      requestOptions["body"] = JSON.stringify({
        images: imageData,
        audio: "" + this.audioData,
        session_id: getUrlParam("session_id", null),
        session_password: getUrlParam("session_password", null),
        usespoof: false,
      });
      fetch(requestsUrl, requestOptions).then(async (response) => {
        const response_payload = await response.json();
        //console.log(this.$route.name);
        this.ageEstimationData = response_payload;

        if (this.$route.name == "face_detection") {
          if (response_payload.meta.status == "success") {
            var data = response_payload.data;
            var strData = "Results:\n";
            //console.log(data.length);
            for (var i = 0; i < data.length; i++)
              strData += "Image " + i + ": " + mapCodeToDisplay(data[i]) + "\n";
            // console.log("data:", data[i]);
            alert(strData);
          } else {
            alert(response_payload.error.code);
          }
          this.reloadVideo();
          return;
        }
        if (this.$route.name == "mask_detection") {
          if (response_payload.meta.status == "success") {
            data = response_payload.data;
            // console.log(data);
            alert("Result: " + mapCodeToDisplay(data));
          } else {
            alert(response_payload.error.code);
          }
          this.reloadVideo();
          return;
        }
        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;
          // this.displayResult = false
          this.isResultScreen = false;
          this.loading = false;
          this.imageProcessRunning = false;
          // console.log("error:", error);
          return Promise.reject(error);
        }
        var meta = response_payload.meta;
        var avgConfid = 0;
        if (response_payload.meta.status == "success") {
          data = response_payload.data;
          //console.log(data);

          let sumScores = data.septenary_confidences; // TODO: check.
          let exact_age = data.specific_age_estimation;

          if (exact_age != "disabled") {
            let interval = this.calculateMinMax(sumScores);

            this.overallResult =
              interval[1] > 50 || exact_age > 50
                ? "50+"
                : interval[0].toFixed(1) + " - " + interval[1].toFixed(1);

            this.overallConfidence = "%95";
          }

          this.audioResultLabel = "-";
          this.audioResultConfidence = "No speech detected";
          this.loading = false;
          this.isResultScreen = true;
          this.isRecordingScreen = false;
          this.imageProcessRunning = false;
          this.estimationCompleted = true;

          // iFrame CODE SNIPPET
          var pass_data = {
            age_identified: this.overallResult,
            score: this.overallConfidence,
            verified: "true",
          };
          if (this.transaction_id != null) {
            var reportingRequestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              }, //
            };

            reportingRequestOptions["body"] = JSON.stringify({
              request_type: "complete_transaction",
              transaction_id: this.transaction_id,
              api_key: getUrlParam("api_key", null),
              api_secret: getUrlParam("api_secret", null),
              browser_response_data: {
                age: this.overallResult,
                age_confidence: this.overallConfidence,
                genuineness: 1.0,
                product: "age",
                modality: "image",
              },
            });
            fetch(this.reportingURL, reportingRequestOptions).then(
              async (response) => {
                console.log("Response logged");
              }
            );
          }
          parent.postMessage(JSON.stringify(pass_data), "*");
        } else if (response_payload.meta.status == "error") {
          console.log(response_payload.error.code);
          if (response_payload.error.code == "no_face_detected") {
            alert(
              "No faces were detected - make sure your video camera is on and you're looking at it."
            );
          } else if (response_payload.error.code == "multiple_faces_detected") {
            alert(
              "Multiple faces were detected - make sure you're the only one front of the camera."
            );
          } else if (response_payload.error.code == "insufficient_brightness") {
            alert(
              "Poor image quality. Please adjust your position to the light source and be more stable"
            );
          } else if (response_payload.error.code == "spoof_detected") {
            alert(
              "Could not reliably detect your age. Please be in a well-illuminated environment, position yourself better to the light source, and stay more stable in front of the camera. You may want to remove your glasses or mask as well."
            );
          } else if (response_payload.error.code == "no_voice") {
            alert(
              "No speech detected. Please make sure that your microphone is open and close to you."
            );
          } else if (response_payload.error.code == "image_too_blurry") {
            alert(
              "The image is too blurry/out of focus. Please make sure you're remaining still and your camera lens is clean."
            );
          } else if (response_payload.error.code == "mask_detected") {
            alert(
              "Your face appears to be partially covered. Please consider removing your mask and glasses."
            );
          } else if (response_payload.error.code == "no_valid_images") {
            alert(
              "No faces were detected - make sure your video camera is on and you're looking at it."
            );
          } else if (response_payload.error.code == "general_error") {
            console.log(response_payload);
            alert(
              "An error occurred while analyzing your video - please try again."
            );
          }

          console.log("error:", response_payload.error.code);
          if (this.isSafari) {
            window.location.reload();
          } else {
            this.reloadVideo();
          }
          this.tryAgain();
        }
        this.stream.getTracks().forEach(function (track) {
          try {
            track.stop();
          } catch (error) {
            console.log("Could not close track, reason: ", error);
          }
        });
        return data;
      });
    },
    async fallback_predict(imageItems, b64) {
      if (imageItems.length < total_frames_to_analyze) {
        alert(
          "Could not sample enough number of straight looks, please come closer to the camera, and make sure that you are not wearing a mask."
        );
        this.tryAgain();
        return;
      }
      this.audioData = b64;
      let imageData = [];
      for (var i = 0; i < 5 && i < imageItems.length; i++) {
        var canvas = document.createElement("canvas");
        canvas.width = imageItems[i].width; // or 'width' if you want a special/scaled size
        canvas.height = imageItems[i].height; // or 'height' if you want a special/scaled size

        canvas.getContext("2d").putImageData(imageItems[i], 0, 0); //drawImage(imageItems[i], 0, 0)
        imageData.push(canvas.toDataURL("image/jpeg"));
      }

      while (imageData.length < 5) {
        imageData.push(imageData[0]);
      }

      this.transmitdata(imageData);
    },

    async onResult(data) {
      resultPresented = true;
      this.isRecording = false;
      this.imageProcessRunning = false;
      this.$refs.video.srcObject = undefined;
      var resultDownload = this.$refs.videoDownload;
      var blobData;
      const resultValue = window.URL.createObjectURL(data, {
        type: "video/mpeg",
      });
      this.$refs.video.src = resultValue;
      var reader = new FileReader();
      var ref = this;
      reader.onload = function () {
        var b64 = reader.result.replace(/^data:.+;base64,/, "");
        ref.loading = true;
        ref.processVideo(b64);
      };
      reader.readAsDataURL(data);
      setTimeout(() => {
        window.URL.revokeObjectURL(resultValue);
      }, 1000);
      this.$refs.video.src = resultValue;
    },
    onProcessResult: async (result) => {},
  },
};
</script>

<style scoped>
.overlayCircle {
  position: relative;
  margin-top: 0px;
}

.hero {
  background: url("../../assets/images/arcoscan/dark-bg.png") !important;
  background-size: cover !important;
  background-position: center !important;
  background-attachment: fixed !important;
  height: 100vh !important;
}

.arcoscan-title {
  color: var(--neutral-900, #111827);
  /* H1/Bold/Desktop */
  font-family: Mukta;
  font-size: 96px;
  font-style: normal;
  font-weight: 700;
  line-height: 112px; /* 116.667% */
  letter-spacing: -1.92px;
}

.arcoscan-subtitle {
  color: var(--neutral-900, #111827);
  /* Body1/Regular */
  font-family: Mukta;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}

.arcoscan-title-2 {
  color: var(--neutral-800, #1f2937);
  text-align: center;
  font-size: 34px;
  font-family: Mukta;
  font-style: normal;
  font-weight: 600;
  line-height: 138.4%;
}

.underline_text {
  border-bottom: solid 3px #111827;
  display: inline;
}

.circle {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  padding: 4px;
  background: #fff;
  border: 1px solid var(--neutral-400, #9ca3af);
  text-align: center;
  color: var(--neutral-800, #1f2937);
  font-size: 15px;
  font-family: Mukta;
  font-style: normal;
  font-weight: 700;
}

.arcoscan-item {
  color: var(--neutral-900, #111827);
  font-size: 16px;
  font-family: Mukta;
  font-style: normal;
  font-weight: 500;
  line-height: 138.4%;
}

.arcoscan-button {
  border-radius: 8px;
  color: #fff;
  background: #6eaae5;
  text-transform: unset;
  width: 83px;
  height: 44px;
}

.header-cl {
  position: relative;
  width: 100%;
  margin-top: -20px;
}

.mobile-header-cl {
  position: relative;
  width: 100%;
}

.arcoscan-age-estimation-text {
  color: var(--neutral-900, #111827);

  /* H5/Bold/Desktop */
  font-family: Mukta;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 133.333% */
  letter-spacing: -0.48px;
}

.text-box-desktop {
  position: absolute;
  padding: 10px;
  height: auto;
  bottom: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: rgba(49, 76, 102, 0.3);
  border-radius: 8px;
  border: 2px solid var(--generic-white, #fff);
  backdrop-filter: blur(5px);
  /* max-width: 50%; */
  max-width: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;

  @media (min-width: 1280px) {
    max-width: 75%;
  }
}

.left-center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 14%;
  text-align: left;
  bottom: auto;
  max-width: 250px;
}

.dynamic-text-desktop {
  color: var(--generic-white, #fff);
  text-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1),
    0px 1px 2px rgba(16, 24, 40, 0.1);
  font-family: Mukta;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.68px;
}

.overlaytext-cl-mobile {
  border-radius: 8px;
  border: 2px solid var(--generic-white, #fff);
  background: rgba(49, 76, 102, 0.3);
  color: var(--generic-white, #fff);
  /* Elevation/2 */
  text-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1),
    0px 1px 2px rgba(16, 24, 40, 0.1);
  font-family: Mukta;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 123.529% */
  letter-spacing: -0.68px;
  padding: 5px;
}

.arcoscan-button-disabled {
  border-radius: 8px;
  background: var(--neutral-300, #d1d5db);
  text-transform: unset;
  background: #d1d5db;
  color: #fff;
  width: 83px;
  height: 44px;
}

.arcoscan-success-msg {
  color: var(--neutral-900, #111827);
  /* H3/Bold/Desktop */
  font-family: Mukta;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 56px; /* 116.667% */
  letter-spacing: -0.96px;
}

.estimation-title {
  color: var(--neutral-900, #111827);
  text-align: center;

  /* H4/Regular/Desktop */
  font-size: 34px;
  font-family: Mukta;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: -0.68px;
}
</style>
